<template>
  <!-- <vx-card> -->
    <div>
    <vs-prompt
      title="Export To Excel"
      class="export-options"
      @cancle="clearFields"
      @accept="exportToExcel"
      accept-text="Export"
      @close="clearFields"
      :active.sync="activePrompt"
    >
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <div class="export-table">
      <vs-table pagination max-items="5" search :data="productsFiltered">
        <template slot="header">
          <!-- <vs-button @click="activePrompt = true">Export</vs-button> -->
          <vs-button @click="exportToExcel()">Download as CSV</vs-button>
        </template>

        <template slot="thead">
          <vs-th sort-key="product_name"> Name </vs-th>
          <vs-th sort-key="product_code"> Code </vs-th>
          <vs-th sort-key="getPricedType">Priced</vs-th>
          <vs-th sort-key="getPricedBin">Price Diff</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].product_name">{{ data[indextr].product_name }}</vs-td>
            <vs-td :data="data[indextr].product_code">{{ data[indextr].product_code }}</vs-td>
            <vs-td :data="getPricedType(data[indextr])">{{ getPricedType(data[indextr]) }}</vs-td>
            <vs-td :data="getPricedBin(data[indextr])">{{ getPricedBin(data[indextr]) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    </div>
  <!-- </vx-card> -->
</template>

<script>
import vSelect from 'vue-select'
import { fetchArtefactUnit } from "../shared/services";

export default {
  components: {
    vSelect
  },
  props: {
      filter: { type: Object, required: true },
      key: { type: String, required: true }
  },
  data() {
    return {
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'csv',
      headerTitle: ['name', 'code', 'isc', 'cts', 'alco', 'paneco', 'cell', 'asher', 'kris', 'wns', 'fp', 'tls', 'amp', 'max_price', 'min_price', 'second_highest', 'second_lowest', 'high', 'low', 'hamp', 'lamp', 'high_bins', 'low_bins', 'hamp_bins', 'lamp_bins', 'cts_high', 'cts_low'],
      headerVal: ['product_name', 'product_code', 'isc', 'CTS', 'alco', 'paneco', 'cell', 'asher', 'kris', 'wns', 'fp', 'tls', 'amp', 'max_price', 'min_price', 'second_highest', 'second_lowest', 'high', 'low', 'hamp', 'lamp', 'high_bins', 'low_bins', 'hamp_bins', 'lamp_bins', 'cts_high', 'cts_low'],
      products: [
        // {
        //   'product_name': 'Teeling Single Grain 46% 700ml',
        //   'product_code': 'LMDW010',
        //   'isc': 0,
        //   'CTS': 89.67115384615384,
        //   'alco': 100.0,
        //   'paneco': 109.99,
        //   'cell': 104.0,
        //   'asher': 95.0,
        //   'kris': 0,
        //   'wns': 0,
        //   'fp': 0,
        //   'tls': 105.0,
        //   'amp': 100.61019230769232,
        //   'max_price': 109.99,
        //   'min_price': 89.67115384615384,
        //   'second_highest': 109.99,
        //   'second_lowest': 95.0,
        //   'high': 0.0,
        //   'low': 5.609999999999999,
        //   'hamp': 9.32,
        //   'lamp': 10.870000000000001,
        //   'high_bins': 0,
        //   'low_bins': '5-10%',
        //   'hamp_bins': '5-10%',
        //   'lamp_bins': '10-20%',
        //   'cts_high': 0,
        //   'cts_low': 1
        // }
      ],
      productsFilteredForExport: [],
      activePrompt: false,

      isLoading: true,
      payload: {
        tags: [],
        dateRange: {
          startDate: "05/03/2019",
          endDate: "08/03/2019"
        },
        page: {
          size: 20,
          pos: 1
        },
        query: '',
        mode: "quantity",
        type: "PGA",
        res: {}
      },
    }
  },
  methods: {
    getPriceGapInfo() {
      this.isLoading = true;
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#exploreButton",
        // scale: 0.45,
        type: "radius"
      });
      fetchArtefactUnit(this.payload)
        .then(res => {
          this.productsFilteredForExport = [];
          this.products = res.data.skus;
          this.isLoading = false;
          
          this.$vs.loading.close();
        })
        .catch(error => {
          this.products = [];
          this.productsFilteredForExport = [];
          this.isLoading = false;
          this.$vs.loading.close();
          throw new Error(error);
        });
    },

    getPricedType(data) {
      if(data.cts_low === 1){
        return 'Lowest'
      } else if(data.cts_high === 1){
        return 'Highest'
      } else {
        return 'Higher'
      }
    },
    getPricedBin(data) {
      return data.cts_low === 1 ? data.low_bins : data.high_bins 
    },

    exportToExcel() {
      import('@/plugins/Export2Excel').then(excel => {
        const list = this.productsFilteredForExport
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j]
        })
      )
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'csv'
    }
  },
  computed: {
    productsFiltered() {
      let skus = []
      let bucket = 'high_bins'
      let filterCopy = Object.assign([], this.filter);
      if(this.products) {
        skus = this.products.filter(p => {
          if(filterCopy.type === 'low') {
            return p.cts_low === 1
          } else if(filterCopy.type === 'high'){
            return p.cts_high === 1
          } else if(filterCopy.type === 'higher_only'){
            return (p.cts_high === 0 && p.cts_low === 0)
          } else if(filterCopy.type === 'higher_plus'){
            return (p.cts_low === 0)
          } else if(filterCopy.type === 'all') {
            return true
          }
        });
      }

      this.fileName = filterCopy.label;
      if(this.filter.type === 'low') {
        bucket = 'low_bins'
      }
      skus.sort(function (x, y) {
        let xLabelParts = x[bucket].split('-')
        let yLabelParts = y[bucket].split('-')
        return isNaN(xLabelParts[0])  ? -1 : yLabelParts[0] - xLabelParts[0];
      });

      this.productsFilteredForExport = skus;

      return skus;
    }
  },
  mounted() {
    this.getPriceGapInfo();
  }  
}
</script>
